import type { MessageKey } from './pt';

export const en: Record<MessageKey, string> = {
  brand: 'Velha Zap',
  tagline: 'Tic-tac-toe by link — send it on chat and play by turns.',
  yourNickname: 'Your nickname',
  nicknamePlaceholder: 'e.g. Ana',
  startGame: 'Start and play',
  makeFirstMove: 'Make the first move on the board',
  shareChallenge: 'Challenge a friend',
  shareTurn: 'Send move',
  shareResult: 'Share result',
  copyLink: 'Link copied!',
  shareFailed: 'Could not share. Try copying the link.',
  yourTurn: 'Your turn ({mark})',
  waitShare: "Waiting for {name}'s move. Share the link.",
  waitingOpponentName: 'your opponent',
  guestNicknameTitle: 'What should we call you?',
  guestNicknameCta: 'Join the game',
  youAre: 'You are {mark}',
  vs: 'vs',
  winner: '{name} won!',
  draw: "It's a draw!",
  rematch: 'Rematch',
  newGame: 'New game',
  invalidLink: 'This game link is invalid.',
  staleLink: 'This link is outdated. Ask for the latest link in the chat.',
  backHome: 'Back to start',
  themeSystem: 'System',
  themeLight: 'Light',
  themeDark: 'Dark',
  language: 'Language',
  playingAs: 'Playing as {name} ({mark})',
  needNickname: 'Enter a nickname to continue.',
  shareTextTurn: 'Your turn on Velha Zap!',
  shareTextChallenge: 'I challenged you on Velha Zap!',
  shareTextResult: 'Game over on Velha Zap!',
  shareTextRematch: 'Rematch on Velha Zap — you start this time!',
};
